import { BRAND_COLORS } from './pdfConfig';

export const drawHeader = (doc, options = {}) => {
  const {
    companyName = '',
    title = 'REPORTE GENERAL',
    subtitle = '',
    logo = null,
    showLine = true,
    useColors = true
  } = options;

  const pageWidth = doc.internal.pageSize.getWidth();
  const headerHeight = 30;
  const paddingHorizontal = 15;

  // 1. Manejo de Colores
  const bgColor = useColors ? BRAND_COLORS.primary : [255, 255, 255];
  const textColor = useColors ? [255, 255, 255] : [0, 0, 0];

  if (useColors) {
    doc.setFillColor(...bgColor);
    doc.rect(0, 0, pageWidth, headerHeight, 'F');
  }

  // 2. Textos a la IZQUIERDA
  doc.setTextColor(...textColor);
  const textX = paddingHorizontal;

  // Ajuste dinámico de posiciones en el eje Y
  let currentY = companyName ? 13 : 16;

  // --- A. NOMBRE DE LA EMPRESA ---
  if (companyName) {
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(14); // Empresa grande y protagonista
    doc.text(companyName.toUpperCase(), textX, currentY);
    currentY += 6; // Bajamos 6mm para la siguiente línea
  }

  // --- B. TÍTULO DEL DOCUMENTO ---
  doc.setFont('helvetica', 'bold');
  // Si hay empresa, el título se hace un poco más pequeño (10) para respetar la jerarquía
  doc.setFontSize(companyName ? 10 : 14);

  if (!useColors && companyName) {
    doc.setTextColor(0, 0, 0); // Gris muy oscuro para diferenciar el título de la empresa
  }
  doc.text(title.toUpperCase(), textX, currentY);
  currentY += 5; // Bajamos 5mm para el subtítulo

  // --- C. SUBTÍTULO (Metadatos) ---
  if (subtitle) {
    doc.setFontSize(8.5);
    doc.setFont('helvetica', 'normal');
    if (!useColors) doc.setTextColor(0, 0, 0); // Gris más suave para fecha/usuario
    doc.text(subtitle, textX, currentY);
  }

  // 3. Renderizado Proporcional del Logo a la DERECHA
  if (logo) {
    try {
      const maxW = 55; // Ancho máximo
      const maxH = 18; // Alto máximo

      let renderW = 20;
      let renderH = 10;

      // Cálculo de proporción real
      if (logo.naturalWidth || logo.width) {
        const width = logo.naturalWidth || logo.width;
        const height = logo.naturalHeight || logo.height;
        const ratio = width / height;

        renderH = maxH;
        renderW = renderH * ratio;

        if (renderW > maxW) {
          renderW = maxW;
          renderH = renderW / ratio;
        }
      }

      // Centrado vertical dinámico
      const imgY = (headerHeight - renderH) / 2;

      // Alineado al margen derecho
      const imgX = pageWidth - paddingHorizontal - renderW;

      doc.addImage(logo, 'PNG', imgX, imgY, renderW, renderH, undefined, 'FAST');
    } catch (err) {
      console.warn("Error al renderizar logo:", err);
    }
  }

  // 4. Línea Divisoria
  if (showLine) {
    const lineColor = useColors ? BRAND_COLORS.primary : [200, 200, 200];
    doc.setDrawColor(...lineColor);
    doc.setLineWidth(0.3);
    doc.line(paddingHorizontal, 35, pageWidth - paddingHorizontal, 35);
  }
};